<template>
  <!-- Inject OneTrust scripts based on the current language -->
  <!-- We assume $i18n.locale is available. If you store language elsewhere (e.g. Vuex), update this prop. -->
  <OneTrustLoader :currentLanguage="$i18n.locale" />

  <the-navigation></the-navigation>

  <router-view></router-view>

  <the-Footer></the-Footer>
  <CookieBanner />
</template>

<script>
import TheNavigation from './components/Layout/TheNavigation.vue';
import TheFooter from './components/Layout/TheFooter.vue';
import CookieBanner from './components/UI/CookieBanner.vue';
import OneTrustLoader from './components//UI/OneTrustLoader.vue';

export default {
  components: {
    TheNavigation,
    TheFooter,
    CookieBanner,
    OneTrustLoader,
  },
};
</script>

<style>
* {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
}

body {
  margin: 0;
}
</style>